import { ProductPublicModels } from '@features/products/product';
import { capitalize } from '@frontend/common/utils';

/**
 * Build product SEO title from product
 *
 * @param product ProductPublicModels.PublicProduct
 *
 * @returns The product SEO title
 */
export function getProductTitle(product: ProductPublicModels.PublicProduct): string {
    const productFamily = capitalize(product.detail?.familyInfo?.familyName?.toLowerCase());
    const productName = product.name?.replace(/-Studio|-Limited Edition/g, '').trim();
    let productColors = '';
    product.colors?.forEach((color, index) => {
        productColors += capitalize(color.name?.toLowerCase());
        if (index !== product.colors.length - 1) {
            productColors += ', ';
        }
    });

    const titleParts = [productName, productColors, productFamily].filter(Boolean);

    if (titleParts.length > 1) {
        return `${titleParts.join(' · ')} | Massimo Dutti`;
    }

    return `${titleParts[0]} | Massimo Dutti` || 'Massimo Dutti';
}
